import { useContext } from 'react';
import { AuthContext } from '@lp/core/auth';
import { Case, CaseStatus, RoutePlanStatus, ServiceType } from '@/api/apis/case';
import { CaseDetailsPermissions } from '@/permissions';
import { isAllowedStatus } from '@/utils/helpers';

export const useTxCenterPermissions = (caseData: Case) => {
  const { checkPermission } = useContext(AuthContext);

  const hasCasePermission = checkPermission(CaseDetailsPermissions.CaseRetrievalUpdate);
  const hasDAPermission = checkPermission(CaseDetailsPermissions.CaseDARetrievalUpdate);

  const { status, isExpeditedCase, routePlanningStatus, serviceType } = caseData;

  const isDirectAcquisition = serviceType === ServiceType.DirectAcquisition;
  const hasPermission = hasCasePermission || (isDirectAcquisition && hasDAPermission);

  const disableExpeditedCaseEditing =
    isExpeditedCase &&
    ![RoutePlanStatus.PendingResourcesBooking, RoutePlanStatus.ResourcesBooked].includes(routePlanningStatus!);

  const disableEditing =
    disableExpeditedCaseEditing ||
    !isAllowedStatus({ statusTo: CaseStatus.ReturningToBase, currentStatus: status, prohibitDeclined: true }) ||
    !hasPermission;

  return {
    hasPermission,
    disableEditing,
  };
};
